import {
  TRANSACTION_NOT_FOUND_ERROR_CODE,
  TRANSACTION_NOT_FOUND_ERROR_MESSAGE,
  TRANSACTION_BILL_ALREADY_PAID_ERROR_CODE,
  TRANSACTION_BILL_ALREADY_PAID_ERROR_MESSAGE,
  TRANSACTION_POSTPAID_INQUIRY_BILLS_NOT_AVAILABLE_ERROR_CODE
} from '~/components/Buka20/constant';

const BILL_ALREADY_PAID_CODES = [
  TRANSACTION_BILL_ALREADY_PAID_ERROR_CODE,
  TRANSACTION_POSTPAID_INQUIRY_BILLS_NOT_AVAILABLE_ERROR_CODE,
];

export function getInquiryCustomErrorMessage(error) {
  const code = error?.errors?.[0]?.code;
  if (code === TRANSACTION_NOT_FOUND_ERROR_CODE) return TRANSACTION_NOT_FOUND_ERROR_MESSAGE;
  if (BILL_ALREADY_PAID_CODES.includes(code)) return TRANSACTION_BILL_ALREADY_PAID_ERROR_MESSAGE;
  return '';
}
